import { AfterViewInit, Component, ElementRef, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { BaseCustomDialog } from '../base-custom-dialog';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ACTION_DATA_SERVICE, ActionDataService } from '../../../../services/action/data.service';
import {
  IActionTypes,
  LeadAction,
  NotInterestedDetail,
  NotInterestedTypes
} from '../../../../models/action.model';
import { ActionIconHelper } from '../../../../helper/action-icon.helper';
import {
  LeadsMultipleStepByStepService
} from "../../../../services/leads-multiple-step-by-step/leads-multiple-step-by-step.service";
import { ActionHelper } from "../../../../helper/action.helper";

@Component({
  selector: 'fi-close-request-popup',
  templateUrl: './close-request-popup.component.html',
  styleUrls: ['./close-request-popup.component.scss'],
  standalone: false,
})
export class CloseRequestPopupComponent extends BaseCustomDialog implements OnInit {
  contactName = '';
  leadId: number;
  leadTypeId: number;
  selectedTypeId: number;
  selectedTypeName: string;
  notInterestedTypes: IActionTypes[] = [];
  searchedText = '';
  note = '';
  title: string;
  iconUrl = ActionIconHelper.getActionIconUrl('LEAD_NOT_INTERESTED', false);
  darkIconUrl = ActionIconHelper.getActionIconUrl('LEAD_NOT_INTERESTED', true);
  submitting: boolean;
  inValidNote = false;
  isMany: boolean;
  leads: number[];
  step: number = 0;
  private cancel = false;
  @ViewChild('SELECTEDTEXT') selectedText: ElementRef;
  selectActive: any;
  suggestedTypes: {client: NotInterestedTypes[], finstral: NotInterestedTypes[]} = { client: [], finstral: [] }
  private rejectTypes: {client: NotInterestedTypes[], finstral: NotInterestedTypes[]} = { client: [], finstral: [] }

  allOptions: NotInterestedTypes[] = [];
  sectionTextKeys = new Map<number, string>();

  notInterestedDetails: NotInterestedDetail[] = [];
  detailOptions: NotInterestedDetail[] = [];
  detailCaption: string;
  notInterestedDetailId: number = null;

  constructor(
    public dialogRef: MatDialogRef<CloseRequestPopupComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public dialogData: {contactName: string, leadId: number, leadTypeId: number, title: string, leads: number[], isMany: boolean},
    private leadsMultipleStepByStepService: LeadsMultipleStepByStepService,
    @Inject(ACTION_DATA_SERVICE) private actionDataService: ActionDataService
  ) {
    super(dialogRef);

    this.contactName = dialogData?.contactName || '';
    console.log(dialogData.leadTypeId)
    this.leadTypeId = dialogData?.leadTypeId;
    this.leadId = dialogData?.leadId;
    this.title = dialogData?.title;
    this.isMany = dialogData?.isMany;
    this.leads = dialogData?.leads;

   this.getRejectTypes();
   this.getNotInterestedDetails();

    leadsMultipleStepByStepService.listenToCancel().subscribe(data => {
      this.cancel = true;
    })
  }

  @HostListener('window:click', ['$event'])
  closeSelectBoxInOutClick($event: MouseEvent): void {
    if (
      !($event.target as HTMLElement).className.includes('options') &&
      !($event.target as HTMLElement).closest('.options')
    ) {
      this.selectActive = false;
    }
  }


  getRejectTypes(): void {
    const leadTypeId = this.isMany ? null : this.leadTypeId;
    this.actionDataService.getNotInterestedTypes(leadTypeId).subscribe(({ success, data }) => {
      if (!data) {
        return
      }

      this.allOptions = (data as NotInterestedTypes[]).filter(it => !it.Inactive);
      this.allOptions.sort((a, b) => +a.IsFinstral - +b.IsFinstral)

      const firstClientIndex = this.allOptions.findIndex(x => !x.IsFinstral);
      const firstFinstralIndex = this.allOptions.findIndex(x => x.IsFinstral);

      this.sectionTextKeys.set(firstClientIndex, 'ACTION_NOT_INTERESTED_HEADLINE_CONTACT');
      this.sectionTextKeys.set(firstFinstralIndex, 'ACTION_NOT_INTERESTED_HEADLINE_FINSTRAL');
    })
  }

  getNotInterestedDetails(): void {
    this.actionDataService.getNotInterestedDetails().subscribe(({ success, data }) => {
      if (!data) {
        return
      }

      this.notInterestedDetails = data.filter(it => !it.Inactive)
        .sort((a, b) => a.SortOrder - b.SortOrder);
      this.refreshDetailOptions();
    })
  }

  ngOnInit(): void {
  }

  closeDialog(): void {
    this.clearClassAndCloseDialog(this.dialogRef);
  }

  get formIsValid(): boolean {
    if ((this.selectedTypeName === 'CONTACT_OTHER' || this.selectedTypeName === 'FINSTRAL_OTHER') && !this.note?.trim()) {
      return false;
    }
    if (this.isMany) {
      return this.leads.length > 0 && !this.inValidNote && !this.submitting && !!this.selectedTypeId;
    }
    return !!this.leadId && !!this.selectedTypeId && !this.submitting && !this.inValidNote;
  }

  inValidMaxLength(): boolean {
    this.inValidNote = this.note.length > 2000;
    return this.inValidNote;
  }

  submitStepByStep(): void {
    if (this.cancel) {
      return;
    }
    this.clearClassAndCloseDialog(this.dialogRef, 'remove');

    this.actionDataService
      .closeRequest(this.leads[this.step], this.note, this.selectedTypeId, this.notInterestedDetailId).subscribe(({ success, data }) => {
      if (this.leads.length - 1 === this.leads.lastIndexOf(this.leads[this.step])) {
        this.submitting = false;
      }

      this.step++;
      this.leadsMultipleStepByStepService.switchToNextStep();

      if (this.leads[this.step]) {
        this.submitStepByStep();
      }
    });
  }

  submit(): void {
    if (this.formIsValid) {
      this.submitting = true;

      if (this.isMany) {
        let action: any = { Name: 'MULTIPLE_LEADS_STEP_BY_STEP', Text: 'Bald geschafft...'}
        ActionHelper.doAction({} as any, action, this.dialog, this.leads, true)?.afterClosed().subscribe();
        this.submitStepByStep();
      } else {
        this.actionDataService.closeRequest(this.leadId, this.note, this.selectedTypeId, this.notInterestedDetailId).subscribe(({ success, data }) => {
          if (success) {
            this.clearClassAndCloseDialog(this.dialogRef, 'remove');
          }

          this.submitting = false;
        });
      }
    }
  }

  selectNotInterestedDetail($event: string): void {
    this.notInterestedDetailId = $event ? +$event : null;
  }

  toggleSelect($event: Event): void {
    $event.stopPropagation();
    this.selectActive = !this.selectActive;

    if (this.selectActive) {
      this.suggestedTypes = this.rejectTypes;
    }
  }

  showSelect($event: Event): void {
    $event.stopPropagation();
    this.selectActive = true;
    this.suggestedTypes = this.rejectTypes;
  }

  selectResultItem($event: string): void {
    this.selectedTypeId = +$event;
    this.selectedTypeName = this.allOptions.find(item => item.Id === this.selectedTypeId)?.Name;
    this.refreshDetailOptions();

    // the detail belongs to the previously selected reason, so it is never kept
    this.notInterestedDetailId = null;
  }

  /**
   * Details of the currently selected reason, matched via NotInterestedTypeId.
   * The dependent dropdown is only shown when the selected reason has details.
   */
  private refreshDetailOptions(): void {
    const selectedType = this.allOptions.find(item => item.Id === this.selectedTypeId);

    this.detailOptions = this.notInterestedDetails.filter(it => it.NotInterestedTypeId === this.selectedTypeId);
    this.detailCaption = selectedType?.DetailCaption;
  }
}
